// FILE: frontend/src/App.tsx
// Main App component with routing for all three roles - COMPLETE VERSION

import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import RegisterPage from './components/RegisterPage';
import Dashboard from './components/Dashboard';
import BossDashboard from './components/BossDashboard';
import ManagerDashboard from './components/ManagerDashboard';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
};

const AppContent: React.FC = () => {
  const [showRegister, setShowRegister] = useState(false);
  const [loading, setLoading] = useState(true);
  const [userRole, setUserRole] = useState<'admin' | 'manager' | 'boss' | null>(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = () => {
      try {
        // Check for admin/employee token
        const adminToken = localStorage.getItem('token');
        const admin = localStorage.getItem('admin');
        
        // Check for manager token
        const managerToken = localStorage.getItem('managerToken');
        const manager = localStorage.getItem('manager');
        
        // Check for boss token
        const bossToken = localStorage.getItem('bossToken');
        const boss = localStorage.getItem('boss');

        if (bossToken && boss) {
          setUserRole('boss');
          setIsAuthenticated(true);
        } else if (managerToken && manager) {
          setUserRole('manager');
          setIsAuthenticated(true);
        } else if (adminToken && admin) {
          setUserRole('admin');
          setIsAuthenticated(true);
        } else {
          setUserRole(null);
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error('Failed to parse auth data:', error);
        setUserRole(null);
        setIsAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-16 w-16 border-b-4 border-white"></div>
          <p className="mt-4 text-white text-lg font-semibold">Loading Loan CRM...</p>
        </div>
      </div>
    );
  }

  if (isAuthenticated && userRole) {
    return (
      <Routes>
        {userRole === 'boss' && (
          <>
            <Route path="/boss/dashboard" element={<BossDashboard />} />
            <Route path="*" element={<Navigate to="/boss/dashboard" replace />} />
          </>
        )}

        {userRole === 'manager' && (
          <>
            <Route path="/manager/dashboard" element={<ManagerDashboard />} />
            <Route path="*" element={<Navigate to="/manager/dashboard" replace />} />
          </>
        )}

        {userRole === 'admin' && (
          <>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </>
        )}
      </Routes>
    );
  }

  if (showRegister) {
    return (
      <RegisterPage
        onSwitchToLogin={() => setShowRegister(false)}
        onSuccess={() => setShowRegister(false)}
      />
    );
  }

  return <LoginPage onSwitchToRegister={() => setShowRegister(true)} />;
};

export default App;